module.exports = {
  th: require("./th"),
};
